import useAutomaticLogout from './useAutomaticLogout';
import useToken from './useToken';
import useUserActivityTracker from './useUserActivityTracker';

export default function useTokenWatcher() {
  // Handles the token exchange.
  const { token } = useToken();

  // Provides the logout functionality.
  const { scheduleLogOut } = useAutomaticLogout({ token });

  // Logs the user out if they were not active.
  useUserActivityTracker({ onActivity: scheduleLogOut });
}
